import React, { ReactNode } from 'react'
import { Brand, PartialAction, State } from 'src/types'
import { Box, Grid } from '@mui/material'
import { Figures } from 'src/features/brands/components/figures'
import { useLocale } from 'src/locales/useLocale'
import { muiGrey } from 'src/style/muiTheme'

type Props = {
  breadcrumbTrail: string
  figurePanelNum: number
  state: State
  brand: Brand
  children: ReactNode
  dispatch: React.Dispatch<PartialAction>
  handleFigurePanelNum: (_: any, newValue: 0 | 1) => void
}

export const OrderPageTemplate: React.FC<Props> = ({
  children,
  breadcrumbTrail, // パンくず
  figurePanelNum,
  state,
  brand,
  handleFigurePanelNum
}) => {
  const { t } = useLocale()
  const position = state.baseModel.position
  return (
    <Box>
      <Box>
        <Grid container>
          <Grid item xs={12} md={7} zIndex={20} position={'sticky'} top={0}>
            <Box zIndex={20} position="sticky" top={0} width={'100%'}>
              <Box zIndex={20} px={1} py={1} display={'flex'} justifyContent={'space-between'} bgcolor={'#fff'}>
                <Box fontSize={'12px'} color={muiGrey}>
                  {breadcrumbTrail}
                </Box>
                <Box fontWeight={'bold'} fontSize={'12px'} color={muiGrey}>
                  {t.SELECTED_BASE_MODEL}：{state.baseModel?.productNumber}
                </Box>
              </Box>
              <Figures {...{ state, brand, position, figurePanelNum, handleFigurePanelNum }} />
            </Box>
          </Grid>
          <Grid item xs={12} md={5} zIndex={10}>
            <Box py={1}>{children}</Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
